<template>
    <div class="p-3">
        <div v-if="display_loader">
            <img style="height: 50px; width: 100%;" src="/assets/images/icons/loader.svg" />
            <p class="mt-4 mb-0">{{ $t("res_Msgs_LoadingText") }}</p>
        </div>
        <div v-if="display_loader == false" style="height: 100%; width: 100%; display: flex">
            <div class="" style="">
                <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(userInfo.fullName) }}</v-avatar>
            </div>
            <div class="ad__box">
                <p class="ad__text__bold size-16">{{ userInfo.fullName }}</p>
                <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(userInfo) }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import constants from "@/assets/js/constants.js"
import axios from "axios"
import * as utils from '@/assets/js/common.js'

export default {
    name: 'UserInfo',
    components: {},
    props:
    {
        userId: { type: Number, default: 0 },
        structureId: { type: Number, default: 0 },
    },
    data() {
        return {
            userInfo: {
                fullName: '',
                fullNameAr: '',
                email: '',
                title: '',
                titleAr: '',
                profession: '',
                professionAr: ''
            },
            display_loader: true
        }
    },
    watch: {
        userId(newValue, oldValue) {
            if (this.userId && this.userId > 0) {
                this.setUserData();
            }
        },
        structureId(newValue, oldValue) {
            if (this.userId && this.userId > 0) {
                this.setUserData();
            }
        }
    },
    mounted() {
        if (this.userId && this.userId > 0) {
            this.setUserData();
        }
    },
    methods:
    {
        setUserData() {
            this.userInfo = {};
            this.display_loader=true;
            axios.get(constants.baseApiUrl + 'User/GetUserInfo?userId=' + this.userId +'&structureId=' + this.structureId)
                .then(response => {
                    this.userInfo = response.data;
                    this.display_loader=false;
                })
                .catch(error => console.log(error))
        },
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str)
        },
        GetMultiSelectSubHeaderDisplay(options) {
            options.isUser = true;
            return utils.GetMultiSelectSubHeaderDisplay(options)
        }
    },
}
</script>